module.exports = __webpack_public_path__ + "img/scene.0755d4cb.svg";